import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import tr from '../../../libs/tr'
import './MovMinSubPnl.css';
import tab2u from '../../../images/public/userarea/tab2u.png';
import alertb from '../../../images/public/userarea/alertb.png';

class MovMinSubPnl extends Component {

    constructor(props) {
        super(props);
        console.log("props in [MovMinSubPnl] 3: rendering years or months in rows", props);

        this.textym = props.textym ? props.textym : "Text missing!";

        this.state = {
            Alert: false,

            Passyear: props.year,
        };


        this.onClick = this.onClick.bind(this);
    }

    onClick = () => {
        this.props.onClick();
    }

    render() {
        return (
            <div className="movminSubpnl">
                <div className="movpic">
                    <img src={tab2u} className="responsivemovpic" />
                </div>
                <div className="yearMonth">
                    <div style={{color: 'white'}}>{this.textym}&#160;{this.state.Passyear}</div>
                </div>
                {this.state.Alert ?
                    <div className="subalert">
                        <img src={alertb} className="responsive" />
                    </div> : null
                }
                <button className="arrownBtnsub" onClick={this.onClick}></button>
            </div>
        );
    }
}

export default MovMinSubPnl;


// WEBPACK FOOTER //
// ./src/assets/components/panel/MovMinSubPnl.js